const e = 160, a = 180, n = "35px", o = "320px", c = "640px", t = "960px", s = "1280px", r = "8px", p = "16px", i = "4px", b = "0.5rem", m = "#0C2A4DCC", S = "0.25rem", x = "0.5rem", k = "1rem", B = "640px", l = "960px", d = "1280px", g = "0.5rem";
export {
  e as a,
  a as b,
  x as c,
  B as d,
  S as e,
  m as f,
  g,
  b as h,
  k as i,
  i as j,
  r as k,
  p as l,
  n as m,
  l as n,
  d as o,
  o as p,
  c as q,
  t as r,
  s
};
